export default "__VITE_ASSET__Q5XBdxf1__";